'use client';

import { c as _c } from "react/compiler-runtime";
import { formatFiatUnits, hostedQuoteSummary } from '@morfi/onramp-sdk';
import type { FundingCheckout } from '@morfi/onramp-sdk/react';
import { useLocale, useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
export function FundingQuoteSummary(t0) {
  const $ = _c(7);
  const {
    checkout
  } = t0;
  const t = useTranslations("onramp");
  const locale = useLocale();
  if (!checkout.quote || !checkout.review) {
    return null;
  }
  let t1;
  if ($[0] !== checkout.quote || $[1] !== checkout.review || $[2] !== locale || $[3] !== t) {
    const summary = hostedQuoteSummary(checkout.quote, checkout.review);
    const money = units => formatFiatUnits(units, summary.decimals, summary.currency, locale);
    const feeLabels = {
      network: t("hosted_fee_network"),
      ecosystem: t("hosted_fee_ecosystem"),
      moonpay: t("hosted_fee_moonpay")
    };
    t1 = [{
      label: t("hosted_you_pay"),
      value: money(summary.payUnits)
    }, {
      label: t("hosted_principal", {
        asset: summary.asset
      }),
      value: money(summary.principalUnits)
    }, {
      label: t("hosted_crypto_received"),
      value: `${summary.receivedAmount} ${summary.asset}`
    }, {
      label: t("hosted_exchange_rate"),
      value: `${summary.exchangeRate} ${summary.currency}/${summary.asset}`
    }, ...summary.fees.map(fee => ({
      label: feeLabels[fee.kind],
      value: money(fee.units)
    }))];
    $[0] = checkout.quote;
    $[1] = checkout.review;
    $[2] = locale;
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const rows = t1;
  let t2;
  if ($[5] !== rows) {
    t2 = <dl className="flex flex-col gap-3 text-caption md:text-body">{rows.map(_temp)}</dl>;
    $[5] = rows;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
function _temp(row) {
  return <div key={row.label} className="flex items-center justify-between gap-3"><dt className="text-foreground-secondary">{row.label}</dt><dd className="text-right">{row.value}</dd></div>;
}